(function () {
	'use strict';

	// Loop through elements with IDs like "box_customRadio1," "box_customRadio2," etc.
	$('input[id^=box_customRadio]').each(function (index) {
		// Create the additional ID to be appended, e.g., "data-offer-box-1," "data-offer-box-2," etc.
		var additionalId = 'data-offer-box-' + (index + 1);

		// Find the parent of the current input element
		var parentDiv = $(this).parent();

		// Find the next <div> element after the parent
		var nextDiv = parentDiv.next('div');

		// Add the additional ID to the next <div> element's id attribute
		nextDiv.attr('data-test-id', additionalId);
	});

	if($(".product-name").length == 2) {
		$(".product-name").eq(0).attr('id', "test-id-product-name-1");
		$(".product-name").eq(1).attr('id', "test-id-product-name-2");
	}
	else {
		$(".product-name").eq(0).attr('id', "test-id-product-name-1");
	}
})();
